export default "__VITE_ASSET__acIAkqSf__"